export const VIEW_FORM_ROUTES = {
    TOP: `/ja/co/:companyContractDisplayId/form/:formHashPath`,
    COMPLETE: `/ja/co/:companyContractDisplayId/form/:formHashPath/complete`,
    ERROR: `/ja/co/:companyContractDisplayId/form/:formHashPath/error`
};
export const VIEW_FORM_ROUTES_INDEX = Object.keys(VIEW_FORM_ROUTES).reduce((acc, key) => {
    const raw = VIEW_FORM_ROUTES[key];
    const index = `${VIEW_FORM_ROUTES[key]}/index.html`;
    const route = { [key]: [raw, index] };
    return { ...acc, ...route };
}, {});
